export default __webpack_public_path__ + "static/media/step2.fa50d449.webp";